export const serviceDescriptionMap = {
  ethoca: "Ethoca prevents disputes from Mastercard transactions with worldwide coverage.",
  rdr: "RDR prevents disputes from Visa transactions with worldwide coverage.",
  cdrn: "CDRN prevents disputes from Visa transactions, covering only the United States."
}

export const enrollmentStatusMap = {
  active: "Active",
  pending: "Pending",
  enable: "Enable",
  unenrolled: "Unenrolled",
  failed: "Failed",
  needs_help: "Needs Help"
}

export const descriptorStatusTypeMap = {
  pending: "pending",
  pending_unenroll: "warning",
  in_re_enrollment: "pending",
  in_progress: "info",
  active: "success",
  enrolled_elsewhere: "error",
  generic_descriptor: "error",
  banned_descriptor: "error",
  invalid_descriptor: "error",
  unenrolled: "error",
  verification_needed: "warning",
  invalid_arns: "error",
  needs_assistance: "error"
}

export const descriptorStatusTextMap = {
  active: "Active",
  pending: "Pending",
  pending_unenroll: "Pending Unenroll",
  in_re_enrollment: "In Re-enrollment",
  in_progress: "In Progress",
  enrolled_elsewhere: "Enrolled Elsewhere",
  generic_descriptor: "Generic Descriptor",
  banned_descriptor: "Banned Descriptor",
  invalid_descriptor: "Invalid Descriptor",
  unenrolled: "Unenrolled",
  verification_needed: "Verification Needed",
  invalid_arns: "Invalid ARN/BIN/CAID",
  needs_assistance: "Needs Assistance"
}

export const descriptorStatuses = Object.keys(descriptorStatusTextMap)

export const enrollmentBtnTextMap = {
  ethoca: {
    active: "Add more descriptors",
    pending: "Add more descriptors",
    enable: "Add enrollment",
    unenrolled: "Start re-enrollment",
    failed: "Add more descriptors",
    needs_help: "Finish enrollment"
  },
  rdr: {
    active: "Add descriptors and RDR IDs",
    pending: "Add descriptors and RDR IDs",
    enable: "Add enrollment",
    unenrolled: "Start re-enrollment",
    failed: "Add descriptors and RDR IDs",
    needs_help: "Finish enrollment"
  },
  cdrn: {
    active: "Add more descriptors",
    pending: "Add more descriptors",
    enable: "Add enrollment",
    unenrolled: "Start re-enrollment",
    failed: "Add more descriptors",
    needs_help: "Finish enrollment"
  }
}

// `list_of_characteristics` mixes plain facts ("Worldwide", "~72 hours", card-brand icon arrays)
// with a monetary one ("Chargeback fee saved": "~$15"). Only the money is sensitive, so it is
// detected by value rather than by key — the labels are backend-owned and can be renamed there
// without the frontend noticing (CHA1-1354).
export const isMoneyCharacteristic = (value) => typeof value === "string" && value.includes("$")

export const getEnrollmentBtnIcon = (status) => {
  const statusesWithPlus = ["active", "pending", "failed"]
  return statusesWithPlus.includes(status) ? "plus" : null
}
